import { isSome } from '@mbfab/shared'
import { X } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

// 使い方のルール: docs/develop/client_ui/components/feedback.md

export type ResultBannerStatus = 'success' | 'warning' | 'error'

// 操作結果を DOM に残すバナー（一瞬で消えるトーストに頼らない。docs/develop/client_ui/components/feedback.md「ResultBanner」）。
// 手動で閉じるか次の操作で消すまで表示し続ける。見た目は既存画面の2系統を variant で維持する
// （VRT 差分ゼロのため class を揃えない）
export function ResultBanner({
  status,
  message,
  testId,
  onDismiss,
  variant = 'card',
  className,
}: {
  status: ResultBannerStatus
  message: ReactNode
  testId: string
  onDismiss?: () => void
  variant?: 'card' | 'strip'
  className?: string
}) {
  return (
    <div
      data-testid={testId}
      data-status={status}
      role="status"
      aria-live="polite"
      className={cn(
        'flex items-center justify-between gap-2 text-sm',
        variant === 'card' &&
          cn(
            'rounded-xl px-4 py-3 font-bold',
            status === 'success'
              ? 'bg-secondary text-primary'
              : status === 'warning'
                ? 'bg-amber-50 text-amber-800'
                : 'bg-destructive/10 text-destructive',
          ),
        variant === 'strip' &&
          cn(
            'border-b border-border px-4 py-2',
            status === 'success'
              ? 'bg-primary/10 text-primary'
              : status === 'warning'
                ? 'bg-amber-50 text-amber-800'
                : 'bg-destructive/10 text-destructive',
          ),
        className,
      )}
    >
      <span>{message}</span>
      {isSome(onDismiss) && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="通知を閉じる"
          className="rounded-md p-0.5 hover:bg-foreground/10"
        >
          <X className="size-3.5" />
        </button>
      )}
    </div>
  )
}
